import { createSlice } from '@reduxjs/toolkit';
import {
  getStorageItem,
  setStorageItem,
  removeStorageItem,
} from '../../utils/storage';

const ENCOUNTERED_ERRORS_LABEL = 'compodium-preflight-encountered-errors';

export const statusSlice = createSlice({
  name: 'status',
  initialState: {
    video: '',
    microphone: '',
    speaker: '',
    network: '',
    connection: '',
    encountered: getStorageItem(
      localStorage,
      ENCOUNTERED_ERRORS_LABEL,
      [],
      true
    ),
    ignorable: false, // state for the current error
  },
  reducers: {
    setVideoError: (state, action) => {
      if (action.payload && state.video) return;
      state.video = action.payload;
    },
    setMicrophoneError: (state, action) => {
      if (action.payload && state.microphone) return;
      state.microphone = action.payload;
    },
    // if microphone is blocked or dismissed we will not get labels for speaker
    setSpeakerError: (state, action) => {
      const relatedMicrophoneErrors = [
        'microphoneBlocked',
        'microphoneDismissed',
      ];
      if (action.payload && state.speaker) return;
      if (
        action.payload === 'noSpeaker' &&
        relatedMicrophoneErrors.includes(state.microphone)
      )
        return;
      state.speaker = action.payload;
    },
    setNetworkError: (state, action) => {
      if (action.payload && state.network) return;
      state.network = action.payload;
    },
    setNetworkConnection: (state, action) => {
      state.connection = action.payload;
    },
    pushEncounteredError: (state, action) => {
      if (state.encountered.includes(action.payload)) return;
      state.encountered.push({
        type: action.payload.type,
        message: action.payload.message,
      });
      setStorageItem(
        localStorage,
        ENCOUNTERED_ERRORS_LABEL,
        state.encountered,
        true
      );
    },
    clearEncounteredErrors: (state) => {
      state.encountered = [];
      removeStorageItem(localStorage, ENCOUNTERED_ERRORS_LABEL);
    },
    setIgnorable: (state, action) => {
      state.ignorable = action.payload;
    },
  },
});

export const {
  setVideoError,
  setMicrophoneError,
  setSpeakerError,
  setNetworkError,
  setNetworkConnection,
  pushEncounteredError,
  clearEncounteredErrors,
  setIgnorable,
} = statusSlice.actions;

export default statusSlice.reducer;
